import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../models/config';

@Injectable({
  providedIn: 'root'
})
export class AmbassadorsProfileService {

  constructor(private http: HttpClient) { }

  // --- Educational Qualification ---
  AddOrUpdateAmbassadorEducationalQualification(data) {
    return this.http.post(`${Config.apiUrl}/AmbassadorsProfile/AddOrUpdateAmbassadorEducationalQualification`, data);
  }

  DeleteAmbassadorEducationalQualification(id) {
    return this.http.delete(`${Config.apiUrl}/AmbassadorsProfile/DeleteAmbassadorEducationalQualification/${id}`);
  }

  GetAmbassadorEducationalQualification(params) {
    return this.http.get(`${Config.apiUrl}/AmbassadorsProfile/GetAmbassadorEducationalQualification`,{params});
  }

  // --- Work Experience ---
  AddOrUpdateAmbassadorWorkExperience(data) {
    return this.http.post(`${Config.apiUrl}/AmbassadorsProfile/AddOrUpdateAmbassadorWorkExperience`, data);
  }

  DeleteAmbassadorWorkExperience(id) {
    return this.http.delete(`${Config.apiUrl}/AmbassadorsProfile/DeleteAmbassadorWorkExperience/${id}`);
  }

  GetAmbassadorWorkExperience(params) {
    return this.http.get(`${Config.apiUrl}/AmbassadorsProfile/GetAmbassadorWorkExperience`,{params});
  }

  // --- Volunteering Experience ---
  AddOrUpdateAmbassadorVolunteeringExperience(data) {
    return this.http.post(`${Config.apiUrl}/AmbassadorsProfile/AddOrUpdateAmbassadorVolunteeringExperience`, data);
  }

  DeleteAmbassadorVolunteeringExperience(id) {
    return this.http.delete(`${Config.apiUrl}/AmbassadorsProfile/DeleteAmbassadorVolunteeringExperience/${id}`);
  }

  GetAmbassadorVolunteeringExperience(params) {
    return this.http.get(`${Config.apiUrl}/AmbassadorsProfile/GetAmbassadorVolunteeringExperience`,{params});
  }

  // --- CV Operations ---
  UploadAmbassadorCv(data) {
    return this.http.post(`${Config.apiUrl}/AmbassadorsProfile/UploadAmbassadorCv`, data);
  }

  GetAmbassadorCvData(params) {
    return this.http.get(`${Config.apiUrl}/AmbassadorsProfile/GetAmbassadorCvData` , {params});
  }
}
